import type { LucideIcon } from "lucide-react";

interface KpiCard {
  label: string;
  value: string | number;
  Icon: LucideIcon;
  tone: "neutral" | "ok" | "warn" | "primary";
}

const TONE_CLASSES: Record<KpiCard["tone"], string> = {
  neutral: "bg-white border-slate-200 text-slate-700",
  ok: "bg-emerald-50 border-emerald-200 text-emerald-800",
  warn: "bg-rose-50 border-rose-200 text-rose-800",
  primary: "bg-[#2B0C1A] border-[#2B0C1A] text-white",
};

export default function KpiCards({ cards }: { cards: KpiCard[] }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 mb-2">
      {cards.map(({ label, value, Icon, tone }) => (
        <div
          key={label}
          className={`border rounded-lg p-4 transition ${TONE_CLASSES[tone]}`}
        >
          <div className="flex items-center gap-2 mb-1 opacity-80">
            <Icon className="w-4 h-4" />
            <span className="text-xs font-medium">{label}</span>
          </div>
          <div className="text-2xl font-bold">{value}</div>
        </div>
      ))}
    </div>
  );
}
